import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainWrapper from './MainWrapper';
import SummaryPanelPrinting from '../Summary/SummaryPanelPrinting';
import ConfiguratorGuard from '../Configurator/ConfiguratorGuard';

const Router = () => (
  <MainWrapper>
    <main>
      <Routes>
        <Route path="/:promotionSlug" element={<ConfiguratorGuard />} />
        <Route path="/:promotionSlug/descargas" element={<ConfiguratorGuard />} />
        <Route path="/:promotionSlug/:code" element={<ConfiguratorGuard />} />
        <Route path="/:promotionSlug/:code/descargas" element={<ConfiguratorGuard />} />
        <Route path="/:promotionSlug/:code/summary" element={<SummaryPanelPrinting />} />
      </Routes>
    </main>
  </MainWrapper>
);

export default Router;
